import Reveal from './Reveal.jsx';
import { scrollToId } from '../hooks/useActiveSection.js';

export default function CtaBand() {
  return (
    <div className="cta-band">
      <Reveal className="cta-band-inner">
        <h2>Ready for a Healthier Smile?</h2>
        <p>Get in touch with us today — we'd love to hear from you.</p>
        <a
          href="#contact"
          className="btn-white"
          onClick={(e) => {
            e.preventDefault();
            scrollToId('contact');
          }}
        >
          ✉️ Contact Us &rarr;
        </a>
      </Reveal>
    </div>
  );
}
